import { useNavigate } from "react-router-dom";

// Les images doivent être dans /public/assets/img/ (logo21.png, packcar.jpeg)
// ou importées : import logo from "./assets/img/logo21.png";

const styles = `
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

body {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #0f172a, #1e3a8a);
  padding: 20px;
}

.container {
  text-align: center;
  background: #ffffff;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
  max-width: 650px;
  width: 100%;
}

.logo {
  width: 120px;
  height: auto;
  display: block;
  margin: 0 auto 20px auto;
}

.title {
  color: #dc2626;
  font-size: clamp(1rem, 2vw, 1.3rem);
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.5;
  letter-spacing: 1px;
  margin-bottom: 25px;
  max-width: 520px;
  margin-left: auto;
  margin-right: auto;
}

.vehicle-image {
  width: 100%;
  max-width: 350px;
  height: auto;
  border-radius: 15px;
  margin-bottom: 30px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.btn {
  display: inline-block;
  padding: 15px 40px;
  border: none;
  border-radius: 50px;
  background: #2563eb;
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(37, 99, 235, 0.4);
}

.btn:hover {
  background: #1d4ed8;
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.5);
}

@media (max-width: 600px) {
  .container { padding: 25px; }
  .logo { width: 90px; }
  .btn { width: 100%; }
}
`;

export default function Home() {
  const navigate = useNavigate();

  return (
    <>
      <style>{styles}</style>

      <div className="container">
        <img
                      src={require("../../assets/images/logo_fenasu.png")}
                      alt="logo"
                      style={{ width: "200px" }}
                    />

        <h4 className="title">
          TOWED AWAY VEHICLE AT OWNER'S EXPENSE
          <br />
          IF YOU ARE NOT PARKED AT NADINE'S
        </h4>

        <img
          src={require("../../assets/images/packcar.jpeg")}
          alt="Towed Vehicle"
          className="vehicle-image"
        />

        <br />

        <button className="btn" onClick={() => navigate("/prepage")}>
          AGREE AND SIGN IN
        </button>
      </div>
    </>
  );
}
